<template>
    <h1>CoreFeatures</h1>
</template>